import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BackendService} from "../backend/backend.service";

@Injectable({
  providedIn: 'root'
})
export class HcpService {

  constructor( private http: HttpClient, private backendService: BackendService ) { }

  public readAll(){
    return  this.backendService.read('hcp');
  }



  public getDoctors(dat, city= false){

    let data = JSON.parse( JSON.stringify(dat));

    if (!city){
      data = data.filter(d => d['region'] === "1");
    }
    else {
      data = data.filter(d => d['region'] !== "1")
    }
    data = data.sort( (a, b) => parseInt(b['doctors_private'])-parseInt(a['doctors_private']) );

    let rend = {};
    rend = {labels : data.map(d => d['region/city']), data: []};
    rend['data'].push( {label:'private', data: data.map(d => parseInt(d['doctors_private']) )} );
    rend['data'].push( {label:'public', data: data.map(d => parseInt(d['doctors_public']) )} );
    return rend;
  }

  public getPopulation(dat, city= false){

    let data = JSON.parse( JSON.stringify(dat));

    if (!city){
      data = data.filter(d => d['region'] === "1");
    }
    else {
      data = data.filter(d => d['region'] !== "1")
    }

    data = data.sort( (a, b) => parseInt(b['pop_total'])-parseInt(a['pop_total']) );

    let rend = {};
    rend = {labels : data.map(d => d['region/city']), data: []};
    rend['data'].push( {label:'urban', data: data.map(d => parseInt(d['pop_urb']) )} );
    rend['data'].push( {label:'rural', data: data.map(d => parseInt(d['pop_rur']) )} );

    return rend;

  }


  public getMenages(dat, city= false){

    let data = JSON.parse( JSON.stringify(dat));

    if (!city){
      data = data.filter(d => d['region'] === "1");
    }
    else {
      data = data.filter(d => d['region'] !== "1")
    }
    data = data.sort( (a, b) => parseInt(b['menage_total'])-parseInt(a['menage_total']) );

    let rend = {};
    rend = {labels : data.map(d => d['region/city']), data: []};
    rend['data'].push( {label:'urban', data: data.map(d => parseInt(d['menage_urb']) )} );
    rend['data'].push( {label:'rural', data: data.map(d => parseInt(d['menage_rur']) )} );
    return rend;
  }



}
